import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for input label style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiInputLabelStyle = (theme: Theme): ThemeStyle => {
  return {
    formControl: {
      position: 'relative',
      transform: 'none',
      fontSize: 14,
      fontWeight: 'bold',
      color: theme.palette.text.primary,
      marginBottom: 16,
    },
  };
};
